import { MessageBar, MessageBarType } from "office-ui-fabric-react";
import React, { Component } from "react";
import ReactDOM from "react-dom";
import { CDBMain } from "./CDBMain";
import School from "../models/School";
import moment from "moment";

interface SchoolLicenseBannerProps {
    school?: School
}

interface SchoolLicenseBannerState {
    dismissed: boolean;
}

export default class SchoolLicenseBanner extends Component<SchoolLicenseBannerProps, SchoolLicenseBannerState> {
    
    static displayName = SchoolLicenseBanner.name;

    constructor(props: SchoolLicenseBannerProps) {
        super(props);

        this.state = {
            dismissed: false
        };
    }

    async componentDidMount() {

    }

    async componentDidUpdate(prevProps: SchoolLicenseBannerProps, prevState: SchoolLicenseBannerState): Promise<void> {
        if (prevProps.school !== this.props.school) {
            this.setState({ dismissed: false });
        }
    }

    private renderBanner(){

        if (this.state.dismissed === false && this.props.school?.licenseEndDate != undefined) {

            const now = moment();
            const licenseEndDate = moment(this.props.school.licenseEndDate);
            let monthsRemaining = licenseEndDate.diff(now, 'months', true);
            monthsRemaining = Math.floor(monthsRemaining) + 1; // Add 1 since licese expires at end of month

            if (monthsRemaining === 0) {
                return (
                    <div className="message-bar-container">
                        <MessageBar messageBarType={MessageBarType.warning} onDismiss={() => this.setState({ dismissed: true })}>
                            The school license for <strong>{this.props.school?.schoolName}</strong> will expire this month. Please contact your IT support to renew with Cloud Design Box.
                        </MessageBar>
                    </div>
                );
            }
            else if (monthsRemaining < 0) {
                return (
                    <div className="message-bar-container">
                        <MessageBar messageBarType={MessageBarType.error} onDismiss={() => this.setState({ dismissed: true })}>
                            The school license for <strong>{this.props.school?.schoolName}</strong> has expired. Please contact your IT support to renew with Cloud Design Box.
                        </MessageBar>
                    </div>
                );
            }
        }
    }

    render() {
        const parent = document.querySelector(`.${CDBMain.contentHeaderClass}`);
        if(parent)
        {
            return ReactDOM.createPortal(this.renderBanner(), parent!);
        }
        else
        {
            return null;
        }
    }
}